import React from 'react';
import Box from '../Box/Box';
import { SxProp } from '../style/sxProp';

export type Props = {
  sx?: SxProp;
};

const LayoutList: React.FC<React.PropsWithChildren<Props>> = ({
  sx,
  children,
}) => (
  <Box
    as="ol"
    sx={{
      width: '100%',
      padding: '0 1',
      listStyle: 'none',
      boxSizing: 'border-box',
      /*
       * & > *:not(:last-child) is the better selector but seems
       * like its not supported on IE11.
       */
      '& > *': {
        marginBottom: '1',
      },
      '& > *:last-child': {
        marginBottom: '0',
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...(sx as any),
    }}
  >
    {React.Children.map(children, (child) => (
      <Box as="li">{child}</Box>
    ))}
  </Box>
);

export default LayoutList;
